<template>
  <div v-if="isReady" class="panel-body">
    <div class="text-size-20">
      AmazonのFBA倉庫に長期的に保管されている在庫に対して発生する「長期在庫追加手数料」の対象となる商品情報です。<br>
      毎月5日、20日時点の在庫状況により計算します。
    </div>
    <div v-if="products.length > 0" class="total-longterms">
      <div>FBA長期在庫追加手数料の対象になる商品があります</div>
      <div class="flexbox gap-20 mr-t-10" style="align-items: stretch;">
        <div class="flexbox storage-fee text-gray bg-white">
          <span>在庫保管手数料</span>
        </div>
        <div class="flexbox">
          <i class="fa fa-plus text-gray" aria-hidden="true"></i>
        </div>
        <div class="est-longterm">
          <div>長期在庫追加手数料（次回Amazon請求の見積）</div>
          <div class="text-center">
            <span class="text-size-28">{{ formatNumber(this.totalEstimated ) }}</span> 円
          </div>
        </div>
      </div>
    </div>
    <div class="fba-longterm-banner">
      <div class="fba-longterm-icon"></div>
      <fieldset>
        <legend>注目!</legend>
        <div class="fba-longterm-content">
          手数料を削減できる可能性があります
        </div>
      </fieldset>
    </div>
    <div v-if="products.length > 0" class="fba-longterm-table">
      <premium-modal v-if="cantViewContent" />
      <div class="text-gray text-right">
        基準日：{{ products[0].snapshotDate }}
      </div>
      <table class="full-width bg-white mr-t-10">
        <thead>
          <tr>
            <th class="product-info">商品情報</th>
            <th class="fee">
              次回請求における<br>
              長期在庫追加手数料の対象商品数
            </th>
            <th class="est-fee">
              次回請求における<br>
              長期在庫追加手数料の見積
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in products" :key="index">
            <td class="product-info">
              <div class="flexbox gap-10 no-wrap">
                <img v-if="item.image" :src="item.image" class="w-80" alt="">
                <div>
                  <div class="tooltip-wrapper">
                    <a
                      :href="'https://www.amazon.co.jp/gp/offer-listing/' + item.asin"
                      target="_blank"
                      class="text--underline product-name"
                      >
                      {{ sliceProductName(item.productName) }}
                    </a>
                    <span class="tooltip-text">{{ item.productName }}</span>
                  </div>
                  <div class="flexbox gap-20">
                    <div>
                      <span class="text-gray">SKU：</span>
                      <b>{{ item.sku }}</b>
                    </div>
                    <div>
                      <span class="text-gray">ASIN：</span>
                      <b>{{ item.asin }}</b>
                    </div>
                    <div>
                      <span class="text-gray">FNSKU：</span>
                      <b>{{ item.fnsku }}</b>
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td class="fee">
              <div class="flexbox justify-right gap-20">
                <div>
                  <span class="text-size-28">{{ formatNumber(item.totalQuantity) }}</span> 個
                </div>
                <button type="button" class="btn btn-primary w-100 text-size-20" data-toggle="collapse" :data-target="`#${getItemId(item)}`" @click="handleExpand($event)">
                  内訳
                  <i class="fa fa-chevron-down" aria-hidden="true"></i>
                </button>
              </div>
              <div :id="getItemId(item)" class="collapse fee-data">
                <div v-for="(value, title, i) in item.quantity" :key="i" class="fee-item">
                  {{ title }}：
                  <span class="text-green">{{ formatNumber(value) }}</span>
                </div>
              </div>
            </td>
            <td class="est-fee">
              <span class="text-size-28 font-bold">{{ formatNumber(item.totalEstimate) }}</span> 円
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import SalemonAgentService from '@/services/salemonagentservice'
import Util from '@/common/utility'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import AdditionalWarehouseModal from '@/view/warehouses/AdditionalWarehouseModal'
import PremiumModal from './components/PremiumModalOverlay'

export default {
  components: {
    AdditionalWarehouseModal,
    PremiumModal
  },
  data () {
    return {
      isReady: false,
      loader: null,
      expandLock: false,
      products: [],
      totalEstimated: 0
    }
  },
  computed: {
    cantViewContent () {
      return this.$store.getters.getUser.memberPlan === '0' || this.$store.getters.getUser.isPremiumTrial
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      this.loader = this.$loading.show()
      await this.getLongtermStock()
      this.isReady = true
      this.loader && this.loader.hide()
    },
    getItemId (item) {
      return `item-${item.asin}-${item.fnsku}-${item.sku}`.replace(/[^a-zA-Z0-9-_]/g, '')
    },
    formatNumber (number) {
      return Util.formatMoney(number)
    },
    sliceProductName (productName) {
      const length = 80
      if (productName.length <= length) return productName

      return productName.slice(0, length / 2) + ' ... ' + productName.slice(-(length / 2))
    },
    async getLongtermStock () {
      await SalemonAgentService.getLongtermStock()
        .then((response) => {
          this.products = response.data.products
          this.totalEstimated = response.data.totalEstimated
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
    },
    handleExpand (e) {
      if (this.expandLock) return

      this.expandLock = true

      const button = e.currentTarget
      const icon = button.querySelector('i')

      if (icon.classList.contains('fa-chevron-up')) {
        icon.classList.remove('fa-chevron-up')
        icon.classList.add('fa-chevron-down')
      } else {
        icon.classList.remove('fa-chevron-down')
        icon.classList.add('fa-chevron-up')
      }

      setTimeout(() => {
        this.expandLock = false
      }, 300)
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.salemon_agent.longterm.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  }
}
</script>
<style scoped>
.no-wrap {
  flex-wrap: nowrap;
}
.text-gray {
  color: #666;
}
.text-green {
  color: #388e3c;
}
.text-danger {
  color: #c00000;
}
.panel-body::before {
  display: unset;
  content: unset;
}
.panel-body {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.total-longterms{
  color: #cc0000;
  font-size: 20px;
  font-weight: bold;
  background-color: #fbe5d6;
  border-left: 3px solid #cc0000;
  padding: 20px;

  .storage-fee {
    border: 3px dotted #666;
    padding: 20px;
  }
  .est-longterm {
    background-color: #fff;
    padding: 20px;
    width: max-content;
    border: 1px solid #cc0000;
  }
}
.fba-longterm-banner {
  display: flex;
  flex-wrap: nowrap;
  justify-content: left;
  gap: 10px;
  font-size: 20px;
  width: 100%;
  color: #008cc6;
  font-weight: bold;

  .fba-longterm-icon {
    animation: fuwafuwa 3s ease-in-out infinite alternate;
    background: url(https://image-yoshino.sakura.ne.jp/monster/SaleMonAgent.png) no-repeat center center / 90px auto;
    display: inline-block;
    transition: 1.5s ease-in-out;
    width: 100px;
    height: 100px;
  }

  fieldset {
    border: 3px solid #008cc6;
    border-radius: 12px;
    padding: 10px 20px;
    background: #fff;
    display: inline-block;
    position: relative;

    legend {
      color: #008cc6;
      font-weight: bold;
      border-bottom: unset;
      margin-bottom: unset;
      width: unset;
      padding: 0 10px;
    }

    .fba-longterm-content {
      display: flex;
      flex-direction: column;
      gap: 10px;
      .btn-primary {
        align-self: flex-end;
      }
    }
  }
}
.fba-longterm-table:has(.premium-overlay) {
  position: relative;
  overflow: hidden;
}
.fba-longterm-table {
  overflow: auto;
  max-width: 1800px;
  tr {
    border: 1px solid #d9d9d9;
  }
  td, th {
    padding: 5px 10px;
    border: 1px solid #d9d9d9;
  }
  th {
    background-color: #deebf7;
    color: #666;
  }
  .product-info {
    min-width: 60%;
    max-width: 70%;
  }
  td.product-info {
    vertical-align: top;
    .product-name {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      width: 100%;
    }
  }
  .fee, .est-fee {
    min-width: 250px;
  }
  td.fee {
  .fee-data {
      background-color: #e5e5e5;
      margin-top: 5px;
      padding: 10px;
      width: 90%;
      max-height: max-content !important;
      float: right;
      font-size: 18px;
      .fee-item {
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .text-green {
        font-weight: bold;
      }
    }
  }
  td.est-fee {
    text-align: right;
    color: #c00000;
    font-size: 18px;
  }
  .tooltip-wrapper {
    position: relative;
    display: inline-block;
    cursor: pointer;
  }

  .tooltip-text {
    visibility: hidden;
    background-color: #555;
    color: #fff;
    text-align: left;
    padding: 6px 10px;
    border-radius: 6px;
    font-size: 12px;
    position: absolute;
    z-index: 1;
    top: 110%;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 0.3s;
    width: 70%;
  }

  .tooltip-text::after {
    content: '';
    position: absolute;
    top: -10px;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #555 transparent;
  }

  .tooltip-wrapper:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
  }
}
@keyframes fuwafuwa {
  0% {
    transform:translate(0, 0) rotate(-7deg);
  }
  50% {
    transform:translate(0, -7px) rotate(0deg);
  }
  100% {
    transform:translate(0, 0) rotate(7deg);
  }
}

@media (max-width: 425px) {
  .text-size-20 {
    font-size: 14px;
  }
  .fba-longterm-icon {
    display: none !important;
  }
  .fba-longterm-content {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/salemonAgent/LongtermStock.vue